var r = /* @__PURE__ */ ((e) => (e.setDefault = "setDefault", e.setCurrentToAll = "setCurrentToAll", e.setAuto = "setAuto", e.setAutoToAll = "setAutoToAll", e.removeCurrent = "removeCurrent", e.removeAll = "removeAll", e))(r || {}), t = /* @__PURE__ */ ((e) => (e.Pixels = "px", e.Percent = "%", e.Rem = "rem", e.Em = "em", e.ViewportWidth = "vw", e.ViewportHeight = "vh", e))(t || {}), l = /* @__PURE__ */ ((e) => (e.Auto = "auto", e))(l || {});
export {
  r as ActionTypes,
  t as DynamicUnit,
  l as FixedUnit
};
